import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { RecipeSummary } from './useRecipes';

interface UseRecipeDetailReturn {
  recipe: RecipeSummary | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useRecipeDetail(
  recipeId: string | undefined,
  admin = false,
): UseRecipeDetailReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.crafting.recipeDetail(recipeId!),
    queryFn: async () => {
      const path = admin
        ? `/arches/crafting/admin/recipes/${recipeId}`
        : `/arches/crafting/recipes/${recipeId}`;
      const { data } = await api.get<{ recipe: RecipeSummary }>(path);
      return data.recipe;
    },
    enabled: !!recipeId,
  });

  return {
    recipe: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load recipe' : null,
    refresh: () => {
      refetch();
    },
  };
}
